// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webex-meetings-widget {\n  max-width: 100%;\n  min-width: 18.5rem;\n\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  color: var(--wxc-text-color);\n}\n\n.webex-meetings-widget__content {\n  flex: 1;\n  min-height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
